import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["email", "name", "role", "size", "showTooltip", "tooltipAlignment"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// Derived from Kitt
// https://github.com/Typeform/kitt/blob/05d879218730c3562ab6a47329e5e12b4e2acd35/src/components/avatar/avatar.tsx
import { GRID_UNIT } from "../../constants/design";
import { NeutralColors } from "../../constants/colors";
import { useMemo } from 'react';
import getAvatarSources from "./helpers/get-avatar-sources";
import { getElementByText } from "./helpers/getElementByText";
import avatarColors from "./helpers/avatar-colors";
import { avatarBackgrounds } from "./helpers/avatar-background";
import { getInitials } from "./helpers/getInitials";
import { AvatarText, AvatarWrapper, PictureWrapper, ShapeWrapper, Skeleton, Tooltip, Gravatar } from "./avatar.styles";
import { AvatarSize, TooltipAlignment } from "./types";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Avatar = function Avatar(_ref) {
  var email = _ref.email,
    name = _ref.name,
    role = _ref.role,
    size = _ref.size,
    showTooltip = _ref.showTooltip,
    tooltipAlignment = _ref.tooltipAlignment,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useMemo = useMemo(function () {
      return getElementByText(email, avatarColors);
    }, [email]),
    _useMemo2 = _slicedToArray(_useMemo, 1),
    avatarColor = _useMemo2[0];
  var _useMemo3 = useMemo(function () {
      return getElementByText(email, avatarBackgrounds);
    }, [email]),
    _useMemo4 = _slicedToArray(_useMemo3, 2),
    avatarBackgroundShape = _useMemo4[0],
    selectionIndex = _useMemo4[1];
  var initials = useMemo(function () {
    return getInitials(name || email);
  }, [name, email]);
  var maskId = "avatar-mask-".concat(selectionIndex);
  var tooltipContent = role ? "".concat(name, " (").concat(role, ")") : name;
  return /*#__PURE__*/_jsxs(AvatarWrapper, {
    children: [/*#__PURE__*/_jsxs(PictureWrapper, _objectSpread(_objectSpread({
      backgroundColor: avatarColor === null || avatarColor === void 0 ? void 0 : avatarColor.background,
      size: size,
      "aria-label": tooltipContent,
      "aria-describedby": showTooltip ? 'avatar-tooltip' : undefined
    }, props), {}, {
      children: [/*#__PURE__*/_jsx(AvatarText, {
        size: size,
        children: initials
      }), /*#__PURE__*/_jsx(Gravatar, _objectSpread({
        alt: "Gravatar for ".concat(email)
      }, getAvatarSources(email))), /*#__PURE__*/_jsxs(ShapeWrapper, {
        fill: avatarColor === null || avatarColor === void 0 ? void 0 : avatarColor.shape,
        size: size,
        height: GRID_UNIT * 4,
        width: GRID_UNIT * 4,
        children: [/*#__PURE__*/_jsx("mask", {
          height: GRID_UNIT * 4,
          id: maskId,
          maskUnits: "userSpaceOnUse",
          width: GRID_UNIT * 4,
          x: "0",
          y: "0",
          children: /*#__PURE__*/_jsx("circle", {
            cx: GRID_UNIT * 2,
            cy: GRID_UNIT * 2,
            fill: NeutralColors.White,
            r: GRID_UNIT * 2
          })
        }), /*#__PURE__*/_jsx("g", {
          fill: "inherit",
          mask: "url(#".concat(maskId, ")"),
          children: avatarBackgroundShape
        })]
      })]
    })), showTooltip && /*#__PURE__*/_jsx(Tooltip, {
      id: "avatar-tooltip",
      role: "tooltip",
      size: size,
      alignment: tooltipAlignment,
      children: tooltipContent
    })]
  });
};
Avatar.Skeleton = Skeleton;
Avatar.defaultProps = {
  name: '',
  role: '',
  showTooltip: false,
  size: AvatarSize.Medium,
  tooltipAlignment: TooltipAlignment.Center
};
export default Avatar;